<script>
export default {
  props: {
    lastUpdated: {
      type: [String, Number],
      default: () => '',
    },
    isUser: {
      type: Boolean,
      default: () => false,
    },
    userComments: {
      type: Array,
      default: () => [],
    },
    statusUpdates: {
      type: Array,
      default: () => [],
    },
    userList: {
      type: Array,
      default: () => [],
    },
    user: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
